import { SortOrder } from '@/enums/SortOrder';
import Vue from 'vue';
import { Component, Prop, Watch, Emit } from 'vue-property-decorator';
export abstract class Searchable<T> extends Vue implements HasSearchItemsProperty {
  searchText: string = '';

  sorting: { key: string; order: SortOrder } | null = null;

  defaultSortQuery: Sorting<T> = { created_at: SortOrder.DESC, id: SortOrder.ASC };

  abstract searchItemsProperty: string;

  get searchQuery(): Query<T> {
    if (this.searchText === '') {
      return {};
    }
    return this.defaultSearchQuery;
  }

  get sortQuery(): Sorting<T> {
    if (this.sorting === null) {
      return this.defaultSortQuery;
    }

    return { [this.sorting.key]: this.sorting.order, id: SortOrder.ASC };
  }

  get lastAfter(): Array<string | number> {
    // @ts-ignore
    const total = this[this.searchItemsProperty].length;
    // @ts-ignore
    const last: Product = this[this.searchItemsProperty][total - 1];
    if (last && last.sort) {
      return last.sort;
    }

    return [];
  }

  get defaultSearchQuery(): Query<T> {
    // @ts-ignore
    return {
      or: {
        name: [`like:*${this.searchText}*`, `match:${this.searchText}`],
      },
    };
  }
}

export interface HasSearchItemsProperty {
  searchItemsProperty: string;
}
